<div class="py-3">
  <div class="flex overflow-x-auto rounded-lg border">
    <table class="flex-1 w-full table-auto md:table-fixed" [style.borderBottomWidth]="hasTotals ? '0px' : '1px'">
      <thead>
        <tr class="h-10">
          @for (col of columns; track col) {
          <th class="px-4 min-w-[110px] md:min-w-0 md:w-[var(--col-w)] text-left text-sm font-medium leading-normal font-sans whitespace-nowrap" [style.--col-w]="col.width || 'auto'"
            [ngClass]="col.headerColor || 'text-metro-black'" (click)="col.sortable ? onSort(col.name) : null"
            [class.cursor-pointer]="col.sortable">
            {{ col.label | abpLocalization }}
            @if (sortable && col.sortable && sortColumn === col.name) {
            <span class="ml-1">
              {{ sortDirection === 'asc' ? '↑' : '↓' }}
            </span>
            }
          </th>
          }
          @if (actions?.length) {
          <th class="px-4 text-left text-metro-black text-sm font-medium leading-normal font-sans"
            [ngClass]="actionsMenu ? 'w-14' : 'md:w-60'">
            Acciones
          </th>
          }
        </tr>
      </thead>

      <tbody>
        @for (row of paginatedData; track row.id || $index; let isLast = $last) {
        <tr class="border-t border-t-[#d0dee7] font-sans"
          [ngClass]="[getRowClass ? getRowClass(row) : '', isLast && hasTotals ? 'border-b' : '']">
          @for (col of columns; track col) {
          <td class="h-[72px] px-4 min-w-[110px] md:min-w-0 md:w-[var(--col-w)] py-2 text-sm font-normal leading-normal font-sans"
            [style.--col-w]="col.width || 'auto'"
            [ngClass]="[col.textColor || 'text-metro-black', col.noWrap ? 'whitespace-nowrap' : 'break-words']">
            @switch (col.type || 'text') {
            @case ('status') {
            <span class="px-2 py-1 rounded-full text-xs font-medium font-sans whitespace-nowrap"
              [ngClass]="row[col.name] === 'Rejected' ? 'bg-red-800 text-white' : 'bg-metro-secondary text-metro-black'">
              @if (row[col.name] === true) {
              {{ '::Active' | abpLocalization }}
              } @else if (row[col.name] === false) {
              {{ '::Inactive' | abpLocalization }}
              } @else if (row[col.name]) {
              {{ ('::' + row[col.name]) | abpLocalization }}
              } @else {
              -
              }
            </span>
            }
            @case ('price') {
            <span class="inline-block whitespace-nowrap">
              $ {{ row[col.name] | number:'1.0-0' }}
            </span>
            }
            @case ('date') {
            @if (hasRealDate(row[col.name])) {
            {{ row[col.name] | date:'dd/MM/yyyy' }}
            } @else {
            -
            }
            }

            @default {
            @if (col.name === 'orderStatus' && row[col.name]?.startsWith('::')) {
            {{ row[col.name] | abpLocalization }}
            } @else {
            {{ row[col.name] ?? '' }}
            }
            }
            }
          </td>
          }
          @if (actions?.length) {
          <td
            class="h-[72px] px-4 py-2 text-sm font-bold leading-normal tracking-[0.015em] text-metro-blue-secondary font-sans"
            [ngClass]="actionsMenu ? 'w-14 relative' : 'md:w-60'">
            @if (actionsMenu) {
              <button (click)="toggleMenu(row, $index, $event)"
                class="p-1.5 rounded hover:bg-gray-100 text-metro-black"
                aria-label="Acciones">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <circle cx="12" cy="5" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="19" r="2" />
                </svg>
              </button>
              @if (isMenuOpen(row, $index)) {
                <div class="fixed z-20 min-w-[180px] bg-white border rounded-lg shadow-lg py-1 flex flex-col"
                  [style.top.px]="menuPosition.top" [style.left.px]="menuPosition.left">
                  @for (action of getVisibleActionsForRow(row); track action.name || $index) {
                    <button (click)="action.handler(row); closeMenu()"
                      class="text-left px-4 py-2 text-sm hover:bg-gray-50 whitespace-nowrap">
                      {{ getActionLabel(action, row) | abpLocalization }}
                    </button>
                  }
                </div>
              }
            } @else {
            <div class="flex flex-row items-center gap-2">
              @for (action of getVisibleActionsForRow(row); track action.name || $index; let i = $index) {
                <button (click)="action.handler(row)" class="hover:underline whitespace-nowrap">
                  {{ getActionLabel(action, row) | abpLocalization }}
                </button>
                @if (i < getVisibleActionsForRow(row).length - 1) {
                  <span class="text-gray-300 mx-1">|</span>
                }
              }
            </div>
            }
          </td>
          }
        </tr>
        }

        @if (hasTotals) {
        <tr class="font-sans">
          @for (col of columns; track col) {
          <td class="px-4 min-w-[110px] md:min-w-0 md:w-[var(--col-w)] py-2 text-sm leading-normal font-sans font-bold" [style.--col-w]="col.width || 'auto'"
            [ngClass]="col.textColor || 'text-metro-black'">
            @switch (col.type || 'text') {
            @case ('price') {
            @if (hasTotal(col)) {
            <span class="inline-block whitespace-nowrap">
              {{ getFormattedTotal(col) }}
            </span>
            }
            }
            @default {
            {{ getFormattedTotal(col) }}
            }
            }
          </td>
          }
          @if (actions?.length) {
          <td class="px-4 py-2" [ngClass]="actionsMenu ? 'w-14' : 'md:w-60'"></td>
          }
        </tr>
        }
      </tbody>

    </table>
  </div>

  <div class="mt-2">
    <app-metro-pagination [currentPage]="isServerPaginated ? currentPage - 1 : currentPage - 1"
      [totalItems]="isServerPaginated ? totalItems : data.length" (pageChange)="onPageChange($event + 1)"
      [pageSize]="pageSize">
    </app-metro-pagination>
  </div>
</div>
